import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DynamicService } from 'src/app/services/dynamic.service';
import { MasterService } from 'src/app/services/master.service';
import { MessageService } from 'src/app/services/message.service';
import { token } from '../roles.component';
import * as languageLibrary from '../../../../../../services/language'
import { GapTermRange } from 'src/app/models/gap-term-range.model';
import { formatCurrency } from 'src/app/utils/format';
import { clean } from 'src/app/utils/numeric';
@Component({
    selector: '[role-gap]',
    templateUrl: './role-gap.component.html',
    styleUrls: ['./role-gap.component.scss'],
    standalone: false
})
export class RoleGapComponent implements OnInit {
    /**  */
    protected contactId: number

    /**  */
    protected contactRoleId: number = 0

    /**  */
    protected words = languageLibrary.language

    /**  */
    protected language: string = 'EN'

    /**  */
    public gapInformation: FormGroup;

    /**  */
    protected dataIn: string;

    /**  */
    public id: number = 0;

    /**  */
    public calledFrom: string;

    /**
     * Helper method to consistently get the list of term ranges as an Array.
     */
    get terms() {
        return this.gapInformation.controls['terms'] as FormArray;
    }

    constructor(private master: MasterService, private ms: MessageService, private inject: Injector, private serv: DynamicService, private fb: FormBuilder) {
        this.gapInformation = this.fb.group({
            id: new FormControl<number>(null),
            contactId: new FormControl<number>(null, [Validators.required]),
            premiumRateApplied: new FormControl<string>("flatPremium"),
            terms: this.fb.array([])
        })
    }

    ngOnInit(): void {
        this.dataIn = this.inject.get(token);
        this.contactId = this.dataIn['contactId']
        this.contactRoleId = this.dataIn['contactRoleId']
        this.calledFrom = this.dataIn['calledFrom']

        if (!this.contactId) {
            return
        }

        this.gapInformation.get("contactId").setValue(this.contactId)

        this.getGAP()
    }

    deactivateRole() {
        this.serv.outputFromDynamicComponent({ action: "deactivate", contactRoleId: this.contactRoleId });
    }

    public getGAP() {
        this.master.get(`contacts/${this.contactId}/gap`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            if (res.data.contactGAP.length == 0) {
                if (this.calledFrom == "contactAdvancedSearch")
                    this.serv.outputFromDynamicComponent({ action: "setupNeeded", setupNeeded: true, type: "gap" });
                return
            }

            this.setInformation(res.data.contactGAP[0])

            if (this.calledFrom == "contactAdvancedSearch") {
                this.serv.outputFromDynamicComponent({ action: "setupNeeded", setupNeeded: false, type: "gap" });
                return
            }
        })
    }

    public saveGAP() {
        if (!this.gapInformation.valid) {
            return
        }

        const id = parseInt(this.gapInformation.get('id').value)
        if (!id || isNaN(id) || (id <= 0)) {
            this.createGAP()
        }

        this.modifyGAP()
    }

    createGAP() {
        const contactId = parseInt(this.gapInformation.get('contactId').value)
        if (!contactId || isNaN(contactId) || (contactId <= 0)) {
            return
        }

        const payload = {
            premiumRateApplied: this.gapInformation.get('premiumRateApplied').value,
            terms: null
        }

        for (const term of this.terms.controls) {
            if (!payload.terms) {
                payload.terms = []
            }

            payload.terms.push({
                termMonthsFrom: term.get('termMonthsFrom').value,
                termMonthsTo: term.get('termMonthsFrom').value,
                cost: clean(term.get('cost').value),
                premium: clean(term.get('premium').value)
            })
        }

        this.master.post(`contacts/${contactId}/gap`, { information: payload }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            this.setInformation(res.data.contactGAP)

            if (this.calledFrom == "contactAdvancedSearch")
                this.serv.outputFromDynamicComponent({ action: "setupSaved", setupSaved: true, type: "gap" });
        })
    }

    modifyGAP() {
        const id = parseInt(this.gapInformation.get('id').value)
        if (!id || isNaN(id) || (id <= 0)) {
            return
        }

        const contactId = parseInt(this.gapInformation.get('contactId').value)
        if (!contactId || isNaN(contactId) || (contactId <= 0)) {
            return
        }

        const payload = {
            premiumRateApplied: this.gapInformation.get('premiumRateApplied').value,
            terms: null
        }

        for (const term of this.terms.controls) {
            if (!payload.terms) {
                payload.terms = []
            }

            payload.terms.push({
                termMonthsFrom: term.get('termMonthsFrom').value,
                termMonthsTo: term.get('termMonthsFrom').value,
                cost: clean(term.get('cost').value),
                premium: clean(term.get('premium').value)
            })
        }

        this.master.put(`contacts/${contactId}/gap/${id}`, { information: payload }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }
            if (this.calledFrom == "contactAdvancedSearch") {
                this.serv.outputFromDynamicComponent({ action: "setupSaved", setupSaved: true, type: "gap" });
            }

        })
    }

    deleteGAP() {
        const id = parseInt(this.gapInformation.get('id').value)
        if (!id || isNaN(id) || (id <= 0)) {
            return
        }

        const contactId = parseInt(this.gapInformation.get('contactId').value)
        if (!contactId || isNaN(contactId) || (contactId <= 0)) {
            return
        }

        this.master.discard(`contacts/${contactId}/gap/${id}`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.resetInformation()
        })
    }

    resetInformation() {
        this.gapInformation.reset({
            contactId: this.contactId
        })

        this.id = null
    }

    setInformation(info) {
        this.id = parseInt(info["id"])

        this.gapInformation.setValue({
            id: info['id'],
            contactId: info['contactId'],
            premiumRateApplied: info['premiumRateApplied'] || "flatPremium",
            terms:  []
        })

        const ranges: GapTermRange[] = JSON.parse(info['termRange'])
        if (!ranges || (!Array.isArray(ranges)) || (ranges.length <= 0)) {
            return
        }

        for (const range of ranges) {
            this.terms.push(this.fb.group({
                termMonthsFrom: new FormControl<number>(range.termMonthsFrom, []),
                termMonthsTo: new FormControl<number>(range.termMonthsTo, []),
                cost: new FormControl<string>(formatCurrency(range.cost), []),
                premium: new FormControl<string>(formatCurrency(range.premium), [])
            }))
        }
    }

    /**
     * Add a new item to the gap terms ranges form array.
     */
    addTerms = () => {
        const term = this.fb.group({
            termMonthsFrom: [0, []],
            termMonthsTo: [0, []],
            cost: [formatCurrency(0), []],
            premium: [formatCurrency(0), []]
        })

        this.terms.push(term)
    }

    /**
     * Remove one of the gap terms ranges idenitified by the given index.
     * @param index Index of the gap terms range to remove
     */
    discardTerms = (index: number) => {
        if ((index < 0) || (index > (this.terms.length-1))) {
            return
        }

        this.terms.removeAt(index)
    }

}

